import $ from "jquery";
window.initializeOrderPromocodeForm = function (params = {}) {
  const defaultParams = { promocodeApplied: false };
  let { promocodeApplied } = { ...defaultParams, ...params };

  const elements = document.querySelectorAll(".js-order-promocode-behavior");
  elements.forEach((el) => {
    const placeOrderBtn = document.getElementById("placeOrder");
    const placeOrderLink = document.getElementById("placeOrderLink");
    const buyTicketBtn = document.querySelector(".tc-buy-ticket--button");
    const placeOrderUrl = buyTicketBtn?.getAttribute("data-place-order-url");
    const viewUrl = el.getAttribute("data-promo-code-src");
    const promoCodeInput = el.querySelector("[name=promo_code]");
    const applyBtn = el.querySelector("[value=apply_promocode]");

    const changeLocation = () => {
      location.href =
        placeOrderUrl +
        (promoCodeInput.value ? "?promocode=" + promoCodeInput.value : "");
      promoCodeInput.value = "";
    };

    const applyCallback = function (e) {
      e.preventDefault();

      if (
        promoCodeInput.getAttribute("data-initial-promocode") ===
        promoCodeInput.value
      ) {
        return true;
      }
      if (promoCodeInput.value === "") {
        return true;
      }
      removeTriggerEventListeners();

      applyBtn?.setAttribute("disabled", "");
      placeOrderBtn?.setAttribute("disabled", "");
      placeOrderLink?.classList.add("__disabled");
      promoCodeInput.setAttribute("disabled", "");

      $("#orderSidebar").load(
        `${viewUrl}/${encodeURI(promoCodeInput.value)}`,
        function (response, status, xhr) {
          addTriggerEventListeners();
          if (status === "error") {
            $(".alert").remove();
            applyBtn?.removeAttribute("disabled");
            placeOrderBtn?.removeAttribute("disabled");
            placeOrderLink?.classList.remove("__disabled");
            window.showNotification("Network Error");
          }
        }
      );
    };

    function removeTriggerEventListeners() {
      promoCodeInput?.removeEventListener("blur", applyCallback);
      applyBtn?.removeEventListener("click", applyCallback);
      placeOrderBtn?.removeEventListener("mouseenter", applyCallback);
      placeOrderLink?.removeEventListener("mouseenter", applyCallback);
      // placeOrderBtn?.removeEventListener("click", applyCallback);
    }

    function addTriggerEventListeners() {
      promoCodeInput.addEventListener("blur", applyCallback);
      applyBtn.addEventListener("click", applyCallback);
      placeOrderBtn?.addEventListener("mouseenter", applyCallback);
      placeOrderLink?.addEventListener("mouseenter", applyCallback);
      // placeOrderBtn?.addEventListener("click", applyCallback);
      // placeOrderBtn?.addEventListener("click", (e) => {
      //   if (!promocodeApplied) applyCallback(e);
      //   if (promoCodeInput.value) {
      //     fetch(`${viewUrl}/${encodeURI(promoCodeInput.value)}.json`)
      //       .then((result) => result.json())
      //       .then((data) => {
      //         if (data.availability_promo_codes > 0) changeLocation();
      //       })
      //       .catch((err) => console.error(err));
      //   } else location.href = placeOrderUrl;
      // });
    }

    removeTriggerEventListeners();
    addTriggerEventListeners();
  });
};
